import React, { useState, useEffect, useMemo } from "react";
import { ListGroup, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { useNavigate, useLocation } from "react-router-dom";
import CommonModal from "components/CommonModal";
import { useAuth } from "context/UserContext";

const VendorMenu = ({setShowFollowers}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {logout}=useAuth()
  const [showModal2, setShowModal2] = useState(false);
  const [activeVendorTab, setActiveVendorTab] = useState(null);

  const handleCloseModal2 = () => setShowModal2(false);
  const handleShowModal2 = () => setShowModal2(true);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    sessionStorage.clear();
    setShowModal2(false);
    logout()
    // navigate("/");
  };

  const menuItems = useMemo(
    () => [
      {
        id: 1,
        name: "Profile Details",
        icon: "ep:user",
        route: "/vendor/myprofile",
      },
      {
        id: 2,
        name: "Products",
        icon: "carbon:container-software",
        route: "/vendor/products",
      },
      {
        id: 3,
        name: "My Subscription",
        icon: "hugeicons:money-send-flow-02",
        route: "/vendor/mysubscription",
      },
      {
        id: 4,
        name: "Dispute Management",
        icon: "proicons:chat-question",
        route: "/vendor/dispute-management",
      },
      {
        id: 5,
        name: "My Badges",
        icon: "gg:awards",
        route: "/vendor/my-badges",
      },
      {
        id: 6,
        name: "Notifications",
        icon: "mi:notification",
        route: "/vendor/notifications",
      },
      { id: 7, name: "Logout", icon: "humbleicons:logout", route: "/" },
    ],
    []
  );

  // Update active tab based on current route
  useEffect(() => {
    const activeItem = menuItems.find((item) => {
      if (item.id === 1) {
        // Ensure "Products" tab is active for both "/vendor/products" & "/vendor/add-product"
        return (
          // location.pathname.startsWith("/vendor/products") ||
          // location.pathname === "/vendor/addproduct" ||
          // location.pathname === "/vendor/editproduct"
          location.pathname === "/vendor/myprofile"
        );
      }
      return item.route !== "/" && location.pathname.startsWith(item.route);
    });

    if (activeItem) {
      setActiveVendorTab(activeItem.id);
    }
  }, [location.pathname, menuItems]);

  return (
    <ListGroup variant="flush">
      {menuItems.map((item) => (
        <ListGroup.Item
          key={item.id}
          className={activeVendorTab === item.id ? "active" : ""}
          onClick={() => {
            if (item.name === "Logout") {
              handleShowModal2();
            } else {
              setShowFollowers(false)
              navigate(item.route);
            }
          }}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Icon icon={item.icon} color="#000000" fontSize={20} />
          <span style={{ marginLeft: 10 }}>{item.name}</span>
          <div className="ms-auto">
            <Icon icon="mynaui:chevron-right" color="#6E6E73" fontSize={25} />
          </div>
        </ListGroup.Item>
      ))}

      {/* Logout Confirmation Modal */}
      <CommonModal
        title="Logout?"
        para="Are you sure you want to logout?"
        body={
          <div className="btn_Flex">
            <Button
              onClick={handleCloseModal2}
              variant="outline-info"
              className="border-radius-100"
            >
              Cancel
            </Button>
            <Button
              onClick={handleLogout}
              variant="info"
              className="border-radius-100"
            >
              Yes, I'm Sure
            </Button>
          </div>
        }
        show={showModal2}
        onClose={handleCloseModal2}
      />
    </ListGroup>
  );
};

export default VendorMenu;
